import * as SpeechSDK from 'microsoft-cognitiveservices-speech-sdk'

const startPronunciationAssessment = async (text, lang = 'ja-JP') => {
  const speechConfig = SpeechSDK.SpeechConfig.fromSubscription(process.env.REACT_APP_SPEECH_KEY, process.env.REACT_APP_SPEECH_REGION)
  const audioConfig = SpeechSDK.AudioConfig.fromDefaultMicrophoneInput()
  speechConfig.speechRecognitionLanguage = lang
  const pronunciationAssessmentConfig = new SpeechSDK.PronunciationAssessmentConfig(
    text,
    SpeechSDK.PronunciationAssessmentGradingSystem.HundredMark,
    SpeechSDK.PronunciationAssessmentGranularity.Phoneme,
    true
  )
  const recognizer = new SpeechSDK.SpeechRecognizer(speechConfig, audioConfig)
  pronunciationAssessmentConfig.applyTo(recognizer)
  try {
    await (new Promise((resolve, reject) => {
      recognizer.startContinuousRecognitionAsync(() => {
        resolve()
      }, (err) => {
        reject(err)
      })
    }))
    return Promise.resolve(recognizer)
  } catch (error) {
    return Promise.reject(error)
  }
}

const stopPronunciationAssessment = async (recognizer) => {
  let detailedResult
  try {
    let result
    recognizer.recognized = (s, e) => {
      if (e.result.reason === SpeechSDK.ResultReason.RecognizedSpeech) {
        result = e.result
        detailedResult = JSON.parse(e.result.json)
      }
    }
    await (new Promise((resolve, reject) => {
      recognizer.stopContinuousRecognitionAsync(() => {
        recognizer.close()
        resolve()
      }, (err) => {
        recognizer.close()
        reject(err)
      })
    }))
    const pronunciationAssessmentResult = SpeechSDK.PronunciationAssessmentResult.fromResult(result)
    return Promise.resolve({
      detailedResult: detailedResult,
      accuracyScore: pronunciationAssessmentResult.accuracyScore,
      fluencyScore: pronunciationAssessmentResult.fluencyScore,
      completenessScore: pronunciationAssessmentResult.completenessScore
    })
  } catch (error) {
    return Promise.resolve({
      detailedResult: detailedResult
    })
  }
}

const textToSpeech = async (text, lang = 'ja-JP') => {
  const speechConfig = SpeechSDK.SpeechConfig.fromSubscription(process.env.REACT_APP_SPEECH_KEY, process.env.REACT_APP_SPEECH_REGION)
  speechConfig.speechSynthesisLanguage = lang
  const audioConfig = SpeechSDK.AudioConfig.fromDefaultSpeakerOutput()
  const speechSynthesizer = new SpeechSDK.SpeechSynthesizer(speechConfig, audioConfig)
  await (new Promise((resolve, reject) => {
    speechSynthesizer.speakTextAsync(
      text,
      (result) => {
        if (result) {
          speechSynthesizer.close()
        }
        resolve()
      }, (error) => {
        speechSynthesizer.close()
        reject(error)
      })
  }))
}

export {
  startPronunciationAssessment,
  stopPronunciationAssessment,
  textToSpeech
}